import React, { useState, useEffect } from "react";
import axios from "axios";
import { useLoader } from '../../../../context/LoaderProvider.jsx';
const Foodsettlementpage = () => {
    const [searchTerm, setSearchTerm] = useState("");
    const [selectedDate, setSelectedDate] = useState(""); // Single date picker
    const [invoiceData, setInvoiceData] = useState(null);
    const [settlements, setSettlements] = useState([]);
    const [filteredSettlements, setFilteredSettlements] = useState([]);
    const { showLoader, hideLoader } = useLoader();
    // Fetch settlements from API
    useEffect(() => {
        const token = localStorage.getItem("authToken");
        showLoader();
        axios
            .get("https://backend.maamaas.com/food/api/settlements/get/all", {
                headers: {
                    Authorization: `Bearer ${token}`,
                    Accept: "*/*",
                },
            })
            .then((res) => {
                const data = res.data.settlements || res.data;
                setSettlements(data);
                setFilteredSettlements(data);
            })
            .catch((err) => console.error("Error fetching settlements:", err)).finally(() => {
                hideLoader();
            })
    }, []);

    // Filter settlements based on Vendor ID and selected date
    useEffect(() => {
        let filtered = [...settlements];

        // Filter by Vendor ID
        if (searchTerm) {
            filtered = filtered.filter(item =>
                item.vendorId.toString().toLowerCase().includes(searchTerm.toLowerCase())
            );
        }

        // Filter by selected date
        if (selectedDate) {
            filtered = filtered.filter(item => {
                const settlementDate = new Date(item.settlementDate).toISOString().split("T")[0];
                return settlementDate === selectedDate;
            });
        }

        setFilteredSettlements(filtered);
    }, [searchTerm, selectedDate, settlements]);


    const handleExport = () => {
        const headers = ["Vendor ID", "Total Sales", "Service Charges", "To Settle", "Admin Acc", "Vendor Name", "Vendor Acc", "IFSC", "Settlement Date"];
        const rows = filteredSettlements.map((it) => [
            it.vendorId,
            it.totalAmountBeforeTds,
            it.tdsAmount,
            it.amountAfterTds,
            it.superadminAccNo,
            it.holderName,
            it.accountNumber,
            it.ifscCode,
            it.settlementDate,
        ]);

        const csvContent = [headers, ...rows].map(r => r.join(",")).join("\n");
        const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = "settlements.csv";
        link.click();
    };

    const tableHeaderStyle = {
        border: "1px solid #ddd",
        textAlign: "center",
        fontWeight: "bold",
        backgroundColor: "#b15cd6",
        color: "white",
        padding: 6,
    };
    const tableCellStyle = {
        border: "1px solid #ddd",
        textAlign: "center",
        padding: 6,
    };
    const filterSelectStyle = {
        backgroundColor: "#b15cd6",
        color: "#fff",
        border: "none",
        height: "35px",
        borderRadius: "4px"
    };
    return (
        <div >
            {/* Filters and Export Button */}
            <div style={{ display: "flex", flexWrap: "wrap", justifyContent: "space-between", alignItems: "center", marginBottom: 10, gap: 10 }}>
                <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
                    <input
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        placeholder="Search by Vendor ID"
                        style={{ padding: 6, width: 180, borderRadius: '10px' }}
                    />
                    <input
                        type="date"
                        value={selectedDate}
                        onChange={(e) => setSelectedDate(e.target.value)}
                        style={filterSelectStyle}
                    />
                </div>
                <button onClick={handleExport} style={{ padding: "6px 12px", backgroundColor: "#b15cd6", color: "#fff", border: "none", borderRadius: 4, cursor: "pointer" }}>
                    Export CSV
                </button>
            </div>

            {/* Table */}
            <table style={{ width: "100%", borderCollapse: "collapse" }}>
                <thead>
                    <tr>
                        <th style={tableHeaderStyle}>Vendor ID</th>
                        <th style={tableHeaderStyle}>Total Sales</th>
                        <th style={tableHeaderStyle}>Service Charges</th>
                        <th style={tableHeaderStyle}>Commission Charges</th>
                        <th style={tableHeaderStyle}>To Settle</th>
                        <th style={tableHeaderStyle}>Total Cash</th>
                        <th style={tableHeaderStyle}>Admin Acc</th>
                        <th style={tableHeaderStyle}>Vendor Name</th>
                        <th style={tableHeaderStyle}>Vendor Acc</th>
                        <th style={tableHeaderStyle}>IFSC</th>
                        <th style={tableHeaderStyle}>Settlement Date</th>
                    </tr>
                </thead>
                <tbody>
                    {filteredSettlements.map(it => (
                        <tr key={it.adminId}>
                            <td style={tableCellStyle}>{it.vendorId}</td>
                            <td style={tableCellStyle}>₹{it.totalAmountBeforeTds}</td>

                            <td style={tableCellStyle}>-₹{it.tdsAmount}</td>
                            <td style={tableCellStyle}>-₹{it.commission}</td>
                            <td style={tableCellStyle}>{it.finalAmount}</td>
                            <td style={tableCellStyle}>{it.totalCash}</td>
                            <td style={tableCellStyle}>{it.superadminAccNo}</td>
                            <td style={tableCellStyle}>{it.holderName}</td>
                            <td style={tableCellStyle}>{it.accountNumber}</td>
                            <td style={tableCellStyle}>{it.ifscCode}</td>
                            <td style={tableCellStyle}>{it.settlementDate}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default Foodsettlementpage;
